import { gql } from '@apollo/client'

export interface OnDecisionEditPageUpdatedVariables {
  dealId: number
}

export interface OnDecisionEditPageUpdatedResponse {
  onDecisionEditPageUpdated: {
    dataUpdated: boolean
  }
}

export const ON_DECISION_EDIT_PAGE_UPDATED = gql`
  subscription OnDecisionEditPageUpdated($dealId: Int!) {
    onDecisionEditPageUpdated(dealId: $dealId) {
      dataUpdated
    }
  }
`
